export default "__VITE_ASSET__YaqlEg0x__"